import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IndentedCardHeader from '../IndentedCardHeader/IndentedCardHeader.js';
import IndentedCardContent from '../IndentedCardContent/IndentedCardContent.js';
import ReplaceContact from '../Replace/ReplaceContact/ReplaceContact';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class HelpCard extends React.Component {
  constructor(props) {
    super(props);
    this.handleFAQClick = this.handleFAQClick.bind(this);
  }

  state = {
    open: false,
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleFAQClick(i) {
    const { gaEvent } = this.props;

    gaEvent('FAQ', 'Click', this.refs['faq' + i].props.children);
  }

  replaceContactLinks = (content) => {
    const { forceEnglish } = this.props;

    return (
      <ReplaceContact
        content={content}
        action={this.props.toggleContactModal}
        forceEnglish={forceEnglish}
        isLink={true}
      />
    );
  };

  render() {
    const { classes, title, icon, content, subheading, faqs, section, isTop } =
      this.props;

    return (
      <div className={isTop ? classes.root : classes.rootNoPadding}>
        <Card className="Card">
          <IndentedCardHeader
            title={<Typography variant="h3">{title}</Typography>}
            avatar={icon}
            classes={{
              title: classes.title,
              avatar: classes.avatar,
            }}
            section={section}
          />
          <IndentedCardContent
            body={
              <div className={classes.negativeTopMargin}>
                <Divider />
                <Typography className={classes.body} component="div">
                  {this.replaceContactLinks(content)}
                </Typography>
                {faqs && faqs.length > 0 && (
                  <div>
                    <Typography variant="h3" className={classes.cardSubheading}>
                      {subheading}
                    </Typography>
                    <Divider />
                  </div>
                )}
                {faqs &&
                  faqs.map((faq, i) => (
                    <div key={i}>
                      <ExpansionPanel
                        className={classes.expansionPanel}
                        CollapseProps={{ unmountOnExit: true }}
                        onClick={() => this.handleFAQClick(i)}
                      >
                        <ExpansionPanelSummary
                          expandIcon={
                            <ExpandMoreIcon className={classes.expandIcon} />
                          }
                        >
                          <Typography
                            className={classes.expansionPanelTitle}
                            ref={'faq' + i}
                          >
                            {faq.Title}
                          </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                          className={classes.expansionPanelDetails}
                        >
                          <Typography
                            className={classes.expansionPanelContent}
                            component="div"
                          >
                            {this.replaceContactLinks(faq.Content)}
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      <Divider />
                    </div>
                  ))}
              </div>
            }
          />
        </Card>
      </div>
    );
  }
}

HelpCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]).isRequired,
  faqs: PropTypes.array,
  section: PropTypes.string,
  toggleContactModal: PropTypes.func,
  isTop: PropTypes.bool,
  gaEvent: PropTypes.func.isRequired,
  forceEnglish: PropTypes.bool,
};

HelpCard.defaultProps = {
  isTop: true,
  forceEnglish: false,
  toggleContactModal: null,
};

export default withStyles(styles)(HelpCard);
